export const goToHomeLink = (semesterId: number) => `/${semesterId}/home`;
export const goToTasksLink = (semesterId: number) => `/${semesterId}/tasks`;
export const goToQuickSetupLink = (semesterId: number) => `/${semesterId}/term`;
export const goToAwakeLink = (semesterId: number) => `/${semesterId}/awake-time`;
